// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"5dee8cd6e06f8002","311":"fe32b0ee2e586503"}[chunkId] + ".js";
};